import Button from "../../elements/CustomButton/CustomButton";
import Card from "../Card/Card";
import { FormattedMessage } from "react-intl";
// import { Panel } from "react-bootstrap";
import React from "react";
export const EmptyAddAttachmentCard = () => {
  return (
    //   <Panel
    //     eventKey="1"
    //     expanded={true}
    //     // collapsible
    //     header={
    //       <div>
    //         {/* <FormattedMessage id="ids_expenseEdition" /> */}
    //         <b className="caret" />
    //         <Button wd block>
    //           <i className="fa fa-2x fa-plus-circle" />
    //         </Button>
    //       </div>
    //     }
    //   />
    // );

    <Card
      title={
        <span>
          {/* <Button bsStyle="info"> */}
          <FormattedMessage id="ids_addAnAttachment" />
          {/* <i className="fa fa-2x fa-area-chart" /> */}
        </span>
        // </Button>
      }
      textCenter={true}
      ftTextCenter={true}
      stats={
        <Button wd block>
          <i className="fa fa-2x fa-plus-circle" />
        </Button>
      }
    />
  );
};
